import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import IconSvg from "../../../../SharedComponents/IconSvg";
import Image from "react-bootstrap/Image";

const ImageAndTextSectionWithHeader = ({ header, bottomText, imageSrc, text }) => {
  return (
    <Row className="d-flex justify-content-center mx-2 mx-lg-0 mt-5 ">
      <Col
        xs={12}
        md={11}
        lg={10}
        xl={9}
        xxl={8}
        className={" align-content-center  pb-4  "}
        style={{ whiteSpace: "pre-line" }}
      >
        <Row className={"mb-4"}>
          <Col xs={"auto"} className={"align-content-center"}>
            <IconSvg icon={"fourPointStar"}></IconSvg>
          </Col>
          <Col
            xs={"auto"}
            className={" text-32 text-lg-50 align-content-center EB-Garamond   mt-1"}
            style={{ color: "#000" }}
          >
            {header}
          </Col>
        </Row>
        <Row className={"text-16 text-lg-18 "} style={{ color: "#4D4D4D" }}>
          <Col xs={{ order: 1, span: 12 }} md={{ order: 0, span: 5 }}>
            <Image src={imageSrc} width="100%" />
          </Col>
          <Col xs={{ order: 0, span: 12 }} md={{ order: 1, span: 7 }} className={"mb-4"}>
            {text}
          </Col>
          {bottomText && (
            <Col xs={{ order: 2, span: 12 }} className={"mt-4"}>
              {bottomText}
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};
export default ImageAndTextSectionWithHeader;
